module.exports = __webpack_public_path__ + "img/icon16.3154c9d5.png";